if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  }
  customElements.define('media-gallery', MediaGallery)

  customElements.define('tjb-media-gallery', class TJBMediaGallery extends MediaGallery {
    connectedCallback() {
      this.bindListeners()
    }

    bindListeners() {
      const sectionId = this.dataset.sectionId
      const variantRadios = document.getElementById(`VariantRadios-${sectionId}`)

      if (variantRadios) {
        variantRadios.addEventListener('variantChange', this.onVariantChange.bind(this))
      }
    }

    /**
     * when variant changes, iterate over slides and thumbs
     * if the variantId data property contains the current variant ID, then show
     *
     * after, reset pages in the thumbnail slider for new media and update media count for a11y
     */
    onVariantChange(e) {
      const variantId = e.detail.id

      if (variantId) {
        const slides = Array.from(this.querySelectorAll('.product__media-item'))

        slides.forEach(slide => {
          slide.classList.remove('for-variant')
          if (
            typeof slide.dataset.variantIds !== 'undefined' &&
            slide.dataset.variantIds !== null &&
            slide.dataset.variantIds.includes(variantId)
          ) {
            slide.classList.add('for-variant')
          }
        })

        const thumbs = Array.from(this.querySelectorAll('.thumbnail-list__item'))

        let mediaCount = 0

        thumbs.forEach(thumb => {
          thumb.classList.remove('for-variant')

          if (
            typeof thumb.dataset.variantIds !== 'undefined' &&
            thumb.dataset.variantIds !== null &&
            thumb.dataset.variantIds.includes(variantId)
          ) {
            thumb.classList.add('for-variant')
            mediaCount++
          }
        })

        setTimeout(() => {
          const thumbnailContainer = document.getElementById(`Slider-Thumbnails-${this.dataset.sectionId}`)

          if (thumbnailContainer.scrollWidth > thumbnailContainer.clientWidth) {
            thumbnailContainer.parentNode.classList.add('show-arrows')
            Array.from(thumbnailContainer.parentNode.querySelectorAll('.slider-button')).forEach(button => button.removeAttribute('disabled'))
          } else {
            thumbnailContainer.parentNode.classList.remove('show-arrows')
            Array.from(thumbnailContainer.parentNode.querySelectorAll('.slider-button')).forEach(button => button.setAttribute('disabled', 'disabled'))
          }

          thumbnailContainer.parentNode.resetPages()
          thumbnailContainer.scrollLeft = 0
          this.querySelector('.slider-counter--total').textContent = mediaCount
        })
      }
    }
  })
}
